import { createRouter, createWebHistory } from 'vue-router';
import store from '@/utils/store';
import apiHelper from '@/utils/apiHelpers';
import { isRouteInUserModules, loadUserModules } from '@/utils/moduleAccess';

const moduleProtected = { requiresAuth: true, requiresModule: true };

const routes = [
	{ path: '/', component: () => import('@/components/login/LoginView.vue') },
	{ path: '/login', component: () => import('@/components/login/LoginView.vue') },
	{ path: '/create-account', component: () => import('@/components/register/RegisterView.vue') },
	{ path: '/forgot-password', component: () => import('@/components/forgotpassword/ForgotPasswordView.vue') },
	{ path: '/dashboard', component: () => import('@/components/dashboard/DashboardView.vue'), meta: { requiresAuth: true } },
	{ path: '/my-account', component: () => import('@/components/myaccount/MyAccountView.vue'), meta: { requiresAuth: true } },
	{ path: '/accounts/merchants', component: () => import('@/components/account/AccountView.vue'), meta: moduleProtected },
	{ path: '/accounts/customers', component: () => import('@/components/customeraccount/CustomerAccountView.vue'), meta: moduleProtected },
	{ path: '/settings/products', component: () => import('@/components/product/ProductView.vue'), meta: moduleProtected },
	{ path: '/settings/products/:id', component: () => import('@/components/product/EditProductView.vue'), meta: moduleProtected },
	{ path: '/settings/product-categories', component: () => import('@/components/category/CategoryView.vue'), meta: moduleProtected },
	{ path: '/settings/product-uoms', component: () => import('@/components/uom/UomView.vue'), meta: moduleProtected },
	{ path: '/settings/roles', component: () => import('@/components/role/RoleView.vue'), meta: moduleProtected },
	{ path: '/orders', component: () => import('@/components/order/OrderView.vue'), meta: moduleProtected },
	{ path: '/orders/:id', component: () => import('@/components/order/OrderDtlView.vue'), meta: moduleProtected },
	{ path: '/chat-rooms', component: () => import('@/components/chatrooms/ChatRoomView.vue'), meta: moduleProtected },
	{ path: '/price-approvals', component: () => import('@/components/priceapproval/PriceApprovalView.vue'), meta: moduleProtected },
	{ path: '/request-quotations', component: () => import('@/components/requestquotation/RequestQuotationView.vue'), meta: moduleProtected },
	{ path: '/emails', component: () => import('@/components/email/EmailView.vue'), meta: moduleProtected },
	{ path: '/special-orders', component: () => import('@/components/specialorder/SpecialOrderView.vue'), meta: moduleProtected },
	{ path: '/special-orders/:id', component: () => import('@/components/specialorder/SpecialOrderDtlView.vue'), meta: moduleProtected },
	{ path: '/settings/modules', component: () => import('@/components/module/ModuleView.vue'), meta: moduleProtected },
	{ path: '/settings/logs', component: () => import('@/components/logs/LogView.vue'), meta: moduleProtected },
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
});

router.beforeEach(async to => {
	const now = Date.now() / 1000;
	const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
	if (!requiresAuth) return true;
	if (!store.state.loggedUser || !store.state.jwtToken) return '/login';

	if (Number(store.state.loggedUser.token_expiry) <= now) {
		await apiHelper.logout(router, store.state.loggedUser.timelog_id);
		return '/login';
	}

	if (to.matched.some(record => record.meta.requiresModule)) {
		try {
			const modules = await loadUserModules(router);
			const protectedRecord = to.matched.find(record => record.meta.requiresModule);
			if (!isRouteInUserModules(protectedRecord.path, modules)) return '/dashboard';
		} catch (error) {
			console.error('Unable to verify module access:', error);
			return '/dashboard';
		}
	}

	return true;
});

export default router;
